import { Link } from 'gatsby';
import * as React from 'react';
import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { getIcon } from '../../menus';

interface HitProps {
  hit: any;
  dismiss: () => void;
}

/**
 * Custom search result link for data returned by Algolia instant search.
 */
export const Hit = ({ hit, dismiss }: HitProps) => {
  return (
    <Link to={`/${hit.slug}`} className="search-hit" onClick={dismiss}>
      <div className="icon-wrapper">{getIcon(hit.slug)}</div>
      <article>
        <h3>
          <Highlight attribute="title" hit={hit} />
        </h3>
        <p>
          <Snippet attribute="content" hit={hit} />
        </p>
      </article>
    </Link>
  );
};
